import "./App.css";
import { GameStateProvider } from "./GameStateContext";
import Game from "./Game";
import React, { useCallback } from "react";
import HelpBox from "./components/HelpBox";

function App() {
  const gameId = new URLSearchParams(window.location.search).get("gameId");
  const [gameIdInput, setGameIdInput] = React.useState("");
  const toGame = useCallback(() => {
    window.location.href = `/?gameId=${gameIdInput}`;
  }, [gameIdInput]);

  return (
    <div className="TopLevelApp">
      <div className="container">
        {gameId && (
          <GameStateProvider gameId={gameId}>
            <Game />
          </GameStateProvider>
        )}
        {!gameId && (
          <div className="game-creator">
            <div className="ui-title">
              <h3>BOOK-GAME</h3>
            </div>
            <input
              type="text"
              value={gameIdInput}
              onChange={(e) => setGameIdInput(e.target.value)}
              placeholder="Enter game ID"
              maxLength={20}
            />

            <button onClick={toGame}>Go to game</button>
            <button
              onClick={() =>
                setGameIdInput(Math.random().toString(36).substring(2, 15))
              }
            >
              Generate random
            </button>
          </div>
        )}
        <HelpBox />
      </div>
    </div>
  );
}

export default App;
